import { TableHead, SearchData } from "../../../../common/dataClass/Default"
import { Product, productInfoKey } from '../newProductInfo/class'

/**产品搜索数据 */
class ProductSearchData extends SearchData{
  constructor() {
    super()
    /**产品状态 */
    this.status = []
    /**产品分类 */
    this.sort = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    let obj = {
      "productType": this.sort === '' ? null: this.sort,
      "export": this.status.length? this.status : null,
      "text": this.text === '' ? null: this.text
    }
    return obj
  }
}

/**产品表头 */
class ProductTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

/**产品列表 */
class ProductList extends Product{
  constructor() {
    super()
    /**供应商名称 */
    this.supplierName = ''
    /**完成状态 */
    this.infoStatus = '已完成'
  }
  /**导入后端返回的列表数据 */
  backendListDataParsing(obj){
    let pKeys = Object.keys(productInfoKey)
    pKeys.map(key => {
      this[productInfoKey[key]] = obj[key]
    })
    this.supplierName = obj.supplier[0].supplierName
  }
}

/**产品创建模块 */
class ProductNewModule{
  /**创建产品管理表头 */
  static NEWTABLEHEAD(){
    let arr = [
      new ProductTableHead('产品图片', 'img', '100'),
      new ProductTableHead('产品ID/型号', 'model', '150'),
      new ProductTableHead('产品名称', 'name', '150'),
      new ProductTableHead('产品分类', 'sort', '150'),
      new ProductTableHead('产品状态', 'status', '150'),
      new ProductTableHead('计价<br>单位', 'unit', '50'),
      new ProductTableHead('产品包装尺寸<br>(cm)', 'productSize', '150'),
      new ProductTableHead('产品包装重量<br>(kg/单位)', 'weight', '150'),
      new ProductTableHead('外箱包装尺寸<br>(cm)', 'boxSize', '150'),
      new ProductTableHead('外箱包装重量<br>(kg/单位)', 'boxWeight', '150'),
      new ProductTableHead('装箱数量<br>(单位/箱)', 'boxNum', '80'),
      new ProductTableHead('海关编码', 'HSCode', '100'),
      new ProductTableHead('供应商', 'supplierName', '150'),
      new ProductTableHead('创建日期', 'time', '100'),
      new ProductTableHead('信息<br>完成状况', 'infoStatus', '100'),
      new ProductTableHead('操作', 'operate', '100'),
    ]
    return arr
  }
  /**产品基本信息键值对对应表 */
  static PRODUCTINFOKEYOBJECT(){
    return productInfoKey
  }
}

export{
  ProductSearchData, ProductNewModule, ProductList, Product
}
